import { useState, useReducer } from 'react';

const useNumericInput = ({ onChange, name, max, min, value }) => {
  const [state, setState] = useState({ focused: false, hovered: false });
  const [_, forceUpdate] = useReducer((x) => x + 1, 0);

  const handleChange = (event) => {
    let {
      target: { value: newValue },
    } = event;

    setTimeout(() => {
      // @ts-ignore
      forceUpdate();
    }, 0);

    if (/^\d*$/.test(newValue)) {
      if (value === 0) {
        newValue = newValue.replace('0', '');
      }

      newValue = parseInt(newValue || 0, 10);
      if (max && Number(newValue) > max) return onChange(name, max);

      if (min && newValue < min) {
        onChange(name, value);
      }

      return onChange(name, newValue);
    }

    return onChange(name, value);
  };

  const incrementValue = (event?) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const count = Number(value) + 1;

    if (max && count > max) return;

    onChange(name, count);
  };

  const decrementValue = (event?) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const newValue = Number(value) - 1;
    const minValue = min !== undefined ? min : 1;

    if (newValue >= minValue) {
      onChange(name, newValue);
    }
  };

  const handleKeyDown = (event) => {
    switch (event.keyCode) {
      case 38:
        event.preventDefault();
        incrementValue();
        return false;
      case 40:
        event.preventDefault();
        decrementValue();
        return false;
      default:
        break;
    }
  };

  const handleFocus = () => {
    setState(prevState => ({ ...prevState, focused: true }));
  };

  const handleBlur = () => {
    setState(prevState => ({ ...prevState, focused: false }));
  };

  const onMouseEnter = () => {
    setState(prevState => ({ ...prevState, hovered: true }));
  };

  const onMouseLeave = () => {
    setState(prevState => ({ ...prevState, hovered: false }));
  };

  return {
    state,
    handleFocus,
    handleBlur,
    handleChange,
    handleKeyDown,
    onMouseEnter,
    onMouseLeave,
    decrementValue,
    incrementValue,
  };
};

export default useNumericInput;
